import {
  and,
  orderBy,
  query,
  QueryFieldFilterConstraint,
  where,
} from 'firebase/firestore';
import { ID } from 'shared/types/id';
import { TaskPriorityOptions, TaskType } from 'shared/types/task-base';

import { taskConverter } from './converters/task';
import { CollectionOptions, getCollection } from './helpers';

export type TaskFilterOptions = {
  types?: TaskType[];
  lifeAreas?: ID[];
  goals?: ID[];
  ids?: ID[];
  priorities?: TaskPriorityOptions[];
  uncompletedOnly?: boolean;
  minDuration?: number; // in milliseconds (from "more than" filter)
  maxDuration?: number; // in milliseconds (from "less than" filter)
};

export const getFilteredTasks = async (uid: ID, filters: TaskFilterOptions) => {
  const conditions = [
    where('roles.all', 'array-contains', uid),

    !!filters.uncompletedOnly && where('completedAt', '==', null),

    !!filters.ids?.length && where('id', 'in', filters.ids),
    filters.lifeAreas?.length && where('lifeAreaId', 'in', filters.lifeAreas),
    filters.goals?.length && where('goalId', 'in', filters.goals),
    filters.types?.length && where('type', 'in', filters.types),
    filters.priorities?.length &&
      where(
        'priority',
        'in',
        // none and null are basically the same, so if `none` is added, null should be added as well
        filters.priorities.includes(TaskPriorityOptions.None)
          ? [...filters.priorities, null]
          : filters.priorities,
      ),
    filters.minDuration !== undefined &&
      where('timeslot.duration', '>=', filters.minDuration),
    filters.maxDuration !== undefined &&
      where('timeslot.duration', '<=', filters.maxDuration),
  ].filter(Boolean) as QueryFieldFilterConstraint[];

  return query(
    getCollection(CollectionOptions.Tasks).withConverter(taskConverter),
    and(...conditions),
    orderBy('createdAt', 'asc'),
  );
};
